// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { PersonMessageIcon } from '@moia-dev/pace-icons'
import { InAppMessagesAreaRoutes } from './InAppMessagesAreaRoutes'

export const InAppMessagesAreaNavigationIcon = PersonMessageIcon

export const InAppMessagesAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={InAppMessagesAreaRoutes.route}
      Icon={PersonMessageIcon}
    />
  )
}
